import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type FormEvent, useState } from 'react';

import type { TelesalesTargets } from '../api/types';
import { Modal } from '../components/Modal';
import { MutationError } from '../components/MutationError';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';

// TargetsDialog: Tagesziele eines Telefonisten setzen (Leitung). 0 bzw. leer = kein Ziel.
export function TargetsDialog({ userId, name, current, onClose }: { userId: string; name: string; current: TelesalesTargets | null; onClose: () => void }) {
  const { project } = useProject();
  const papi = useProjectApi();
  const queryClient = useQueryClient();
  const [form, setForm] = useState({
    calls: String(current?.calls ?? ''),
    conversations: String(current?.conversations ?? ''),
    appointments: String(current?.appointments ?? ''),
  });
  const num = (v: string) => (v.trim() === '' ? 0 : Math.max(0, Math.round(Number(v)) || 0));
  const save = useMutation({
    mutationFn: () => papi.setTelesalesTargets(userId, { calls: num(form.calls), conversations: num(form.conversations), appointments: num(form.appointments) }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: projectKeys.team(project.id) });
      void queryClient.invalidateQueries({ queryKey: projectKeys.dashboard(project.id) });
      onClose();
    },
  });
  const submit = (e: FormEvent) => {
    e.preventDefault();
    save.mutate();
  };
  const field = (key: keyof typeof form, label: string) => (
    <label className="field">
      <span>{label}</span>
      <input type="number" min={0} inputMode="numeric" value={form[key]} onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
    </label>
  );
  return (
    <Modal title={`Tagesziele für ${name}`} onClose={onClose}>
      <form onSubmit={submit}>
        <p className="muted">Pro Tag. Leer oder 0 = kein Ziel. {name} sieht den Fortschritt auf „Heute“.</p>
        <div className="form-grid">
          {field('calls', 'Anrufe')}
          {field('conversations', 'Gespräche')}
          {field('appointments', 'Termine')}
        </div>
        {save.isError && <MutationError error={save.error} />}
        <div className="modal-actions">
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Abbrechen
          </button>
          <button type="submit" className="btn btn-primary" disabled={save.isPending}>
            Speichern
          </button>
        </div>
      </form>
    </Modal>
  );
}
